import { useSelector } from 'react-redux';

import { userSelector } from 'store/slices/user';

export const useAccessView = () => useSelector(userSelector.isCustomer);

export default useAccessView;
